import React, { useState } from "react";
import Custombutton from "../../utils/Custombutton";

const PaymentMethod = () => {
  const [activeTab, setActiveTab] = useState("tab1"); // Active tab state

  return (
    <div className="buying">
      <div className="row h-100">
        <div className="col-lg-7 d-none d-lg-block d-flex justify-content-center align-items-center">
          <div className="d-flex align-items-center justify-content-center h-100">
            <img
              className="w-75"
              src="/assets/images/Quater.png"
              alt="Quater"
            />
          </div>{" "}
        </div>
        <div className="col-lg-5 ">
          <div className="inner-buy position-relative h-100">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="mb-5"
              width="32"
              height="28"
              viewBox="0 0 32 28"
              fill="none"
              style={{ cursor: "pointer" }}
            >
              <path
                d="M0.700962 12.701C-0.0164757 13.4184 -0.0164756 14.5816 0.700962 15.299L12.3923 26.9904C13.1097 27.7078 14.2729 27.7078 14.9904 26.9904C15.7078 26.2729 15.7078 25.1097 14.9904 24.3923L4.59808 14L14.9904 3.6077C15.7078 2.89026 15.7078 1.72706 14.9904 1.00962C14.2729 0.292182 13.1097 0.292182 12.3923 1.00962L0.700962 12.701ZM32 12.1629L2 12.1629L2 15.8371L32 15.8371L32 12.1629Z"
                fill="white"
              />
            </svg>
            <h1>
              Payment <br /> Method
            </h1>
            <p>Select your preferred payment method</p>

            {/* Tabs */}
            <div className="custom-tabs">
              <div className="tab-buttons w-100 d-flex">
                <button
                  className={`tab-button w-100 ${
                    activeTab === "tab1" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("tab1")}
                >
                  CRYPTO
                </button>
                <button
                  className={`tab-button w-100 ${
                    activeTab === "tab2" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("tab2")}
                >
                  FIAT
                </button>
              </div>

              <div className="tab-content mt-4">
                {activeTab === "tab1" && (
                  <div className="d-flex flex-column align-items-center justify-content-between h-100">
                    <div className="w-100">
                      <Custombutton
                        className={
                          "btn-outline gradient-outline gradient-text mt-5   w-100 Proceed"
                        }
                        label={"Connect wallet"}
                      />
                      <p className="text-danger  text-center mt-3">
                        No supported chain detected
                      </p>
                    </div>
                    <div className="w-100">
                      <div className="w-100">
                        <div
                          className="btn-bg   Proceed  justify-content-between"
                          style={{ cursor: "pointer" }}
                        >
                          <span>0x1230...12664</span>
                          <span>disconnect</span>
                        </div>
                      </div>
                      <div className="position-relative mt-3">
                        <div className="exchange active ">
                           <h5 className="mb-0">
                             Cosmic
                            </h5>
                            <h5 className="mb-0">
                              10
                            </h5>
                        </div>
                      </div>
                      <div className="position-relative mt-3">
                        <div className="exchange ">
                           <h5 className="mb-0">
                             ETH
                            </h5>
                            <h5 className="mb-0">
                              10
                            </h5>
                        </div>
                      </div>
                    </div>
                    <div className="w-100">
                      <p className="text-white text-center mb-5">
                        Supported currencies
                      </p>
                      <img
                        className="w-100 mt-auto"
                        src="/assets/images/currency.png"
                        alt="currency"
                      />
                    </div>
                  </div>
                )}
                {activeTab === "tab2" && (
                  <div className="d-flex flex-column h-100 justify-content-between">
                    <div>
                      <div className="position-relative mb-4">
                        <input type="text" placeholder="Enter Card number" />{" "}
                        <svg
                          className="arrow-icon"
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="24"
                          viewBox="0 0 22 24"
                          fill="none"
                        >
                          <path
                            d="M21.0607 13.0607C21.6464 12.4749 21.6464 11.5251 21.0607 10.9393L11.5147 1.3934C10.9289 0.807611 9.97919 0.807611 9.3934 1.3934C8.80761 1.97919 8.80761 2.92893 9.3934 3.51472L17.8787 12L9.3934 20.4853C8.80761 21.0711 8.80761 22.0208 9.3934 22.6066C9.97919 23.1924 10.9289 23.1924 11.5147 22.6066L21.0607 13.0607ZM0 13.5H20V10.5H0V13.5Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      <div className="position-relative mb-4">
                        <input type="text" placeholder="Card Holder name" />{" "}
                        <svg
                          className="arrow-icon"
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="24"
                          viewBox="0 0 22 24"
                          fill="none"
                        >
                          <path
                            d="M21.0607 13.0607C21.6464 12.4749 21.6464 11.5251 21.0607 10.9393L11.5147 1.3934C10.9289 0.807611 9.97919 0.807611 9.3934 1.3934C8.80761 1.97919 8.80761 2.92893 9.3934 3.51472L17.8787 12L9.3934 20.4853C8.80761 21.0711 8.80761 22.0208 9.3934 22.6066C9.97919 23.1924 10.9289 23.1924 11.5147 22.6066L21.0607 13.0607ZM0 13.5H20V10.5H0V13.5Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="position-relative mb-4">
                            <input type="text" placeholder="Expiry" />{" "}
                            <svg
                              className="arrow-icon"
                              xmlns="http://www.w3.org/2000/svg"
                              width="22"
                              height="24"
                              viewBox="0 0 22 24"
                              fill="none"
                            >
                              <path
                                d="M21.0607 13.0607C21.6464 12.4749 21.6464 11.5251 21.0607 10.9393L11.5147 1.3934C10.9289 0.807611 9.97919 0.807611 9.3934 1.3934C8.80761 1.97919 8.80761 2.92893 9.3934 3.51472L17.8787 12L9.3934 20.4853C8.80761 21.0711 8.80761 22.0208 9.3934 22.6066C9.97919 23.1924 10.9289 23.1924 11.5147 22.6066L21.0607 13.0607ZM0 13.5H20V10.5H0V13.5Z"
                                fill="white"
                              />
                            </svg>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="position-relative mb-4">
                            <input type="text" placeholder="CVV" />{" "}
                            <svg
                              className="arrow-icon"
                              xmlns="http://www.w3.org/2000/svg"
                              width="22"
                              height="24"
                              viewBox="0 0 22 24"
                              fill="none"
                            >
                              <path
                                d="M21.0607 13.0607C21.6464 12.4749 21.6464 11.5251 21.0607 10.9393L11.5147 1.3934C10.9289 0.807611 9.97919 0.807611 9.3934 1.3934C8.80761 1.97919 8.80761 2.92893 9.3934 3.51472L17.8787 12L9.3934 20.4853C8.80761 21.0711 8.80761 22.0208 9.3934 22.6066C9.97919 23.1924 10.9289 23.1924 11.5147 22.6066L21.0607 13.0607ZM0 13.5H20V10.5H0V13.5Z"
                                fill="white"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="btn-outline gradient-outline Proceed   justify-content-between"
                      style={{ cursor: "pointer" }}
                    >
                      <span className="gradient-text">Proceed to pay</span>
                      <span style={{ color: "white !important" }}>$150</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethod;
